// extracted by mini-css-extract-plugin
export default {"wrapper":"Merge_wrapper__bhwkA","icon":"Merge_icon__MS+D8","tooltipWrapper":"Merge_tooltipWrapper__U41kg","unmerge":"Merge_unmerge__CEPkT"};